import React from "react";

import firebaseDb from "../../firebase";
import './Contribute.css';
import Form from "./Form";

const Contribute = () => {

    const addOrEdit = obj => {
        firebaseDb.child('artefacts').push(
            obj,
           err => {
                if (err)
                console.log(err)
            }
        )
        alert("Thank you for your submission ✌🏻")

    };

  return (
    <>
        <div className="form-container">
                
            <Form addOrEdit={addOrEdit}/>
         
        </div>


    </>

  );


}
export default Contribute
